import Vue from 'vue'
import {
	Button,Form ,Field ,RadioGroup, Radio,Cell, CellGroup,Dialog,Skeleton
} from 'vant'

Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Dialog);
Vue.use(Skeleton);

